<template>
  <v-container grid-list-md style="background-color: white;" id="content" v-touch="{
      left: () => swipeLeft(),
      right: () => swipeRight()
    }">
    <v-layout row wrap>
      <v-flex xs12>
        <section style="background-color: white;">
          <p style="text-align: center;">
            <span class="display-1">Day {{ dayNumber }}</span>
          </p>
          <v-layout align-center justify-center>
            <v-flex md8 xs12>
              <!-- <p class="subheading" style="text-align: center;">Scripture</p> -->
              <template v-for="(section, k) in day.scripture">
                <p class="title" style="text-align: center;" :key="k + 100">{{ section.reference }}</p>
                <p style="text-align: center;" :key="k">{{ section.text }}</p>
              </template>
            </v-flex>
          </v-layout>
          <v-layout align-center justify-center>
            <v-flex md8 xs12>
              <br>
              <!-- <p class="display-1" style="text-align: center;">Handel's Messiah</p> -->
              <template v-for="(section, j) in day.music">
                <p :key="j" style="text-align: center;">
                  <span class="title">{{ section.name }}</span>
                  <span class="ml-2"><a target="_blank" :href="section.link">Listen</a></span>
                </p>
                <p :key="j + 100" style="text-align: center;">{{ section.text }}</p>
                <br :key="j + 200">
              </template>
            </v-flex>
          </v-layout>
        </section>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { data } from '@/assets/data.json'
import { getDay } from '@/components/dateCalc'

export default {
  data () {
    return {
      data: data
    }
  },

  created () {
    if (!this.$route.params.id) {
      this.$router.push({ name: 'day', params: { id: getDay() } })
    }
  },

  methods: {
    swipeLeft: function () {
      var routeNum = this.$route.params.id
      if (routeNum) {
        var newDay = parseInt(routeNum) + 1
        if (newDay > 28) {
          newDay = 1
        }
        this.$router.push({ name: 'day', params: { id: newDay } })
      }
    },

    swipeRight: function () {
      var routeNum = this.$route.params.id
      if (routeNum) {
        var newDay = parseInt(routeNum) - 1
        if (newDay < 1) {
          newDay = 28
        }
        this.$router.push({ name: 'day', params: { id: newDay } })
      }
    }
  },

  computed: {
    day: function () {
      return data[this.dayNumber - 1]
    },

    dayNumber: function () {
      var routeNum = this.$route.params.id
      if (routeNum) {
        return parseInt(routeNum)
      }
      return getDay()
    }
  },

  metaInfo: {
    // title: 'My Page Title',
    // // Result: My Page Title ← My Site
    // // If a child changes the title to "My Other Page Title",
    // // it will become: My Other Page Title ← My Site
    // titleTemplate: '%s ← Handel\'s Messiah',
    // Define meta tags here.
    meta: [
      { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { name: 'description', content: 'Handel\'s Messiah Advent Devotional' },
      { name: 'keywords', content: 'handel,messiah,advent,christmas' }
    ]
  }
}
</script>

<style>
#content::-webkit-scrollbar {
  display: none;
}

::-webkit-scrollbar {
    display: none;
}
</style>
